import request from "@/utils/request";

export async function getUserNotifications(userId) {
  const result = request(
    `${REACT_APP_API_BASE_URL_NEW}/api/notification-service/user-notification-settings/${userId}`,
    {
      method: "GET",
    },
  );

  return (await result).data;
}

export async function setUserNotifications(settingsId, data) {
  const result = request(
    `${REACT_APP_API_BASE_URL_NEW}/api/notification-service/user-notification-settings/${settingsId}`,
    {
      method: "PUT",
      data,
    },
  );

  return (await result).data;
}

export async function getMyNotificationSettings() {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/notification-service/user-notification-settings/my`, {
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function setMyNotificationSettings(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/notification-service/user-notification-settings/my`, {
    method: "PUT",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function getNotificationTemplates(roleType) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/notification-service/notification-templates`, {
    method: "GET",
    params: {
      roleType,
    },
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function getCurrentNotificationSettings() {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/notification-service/user-notification-settings/my`, {
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function setCurrentNotificationSettings(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/notification-service/user-notification-settings/my`, {
    method: "PUT",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}
